import { useState, useEffect } from "react";
import { ProTable } from "components";
import { getRowIds } from "helpers/data/dataHandling";
import { ManagedStocksPopup } from "popups/ManagedStocks/ManagedStocks";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { addDeselectedRows, addSelectedRows, getDepartmentStocks, updateDepartmentField, deleteStocksFromDepartment, importStockToSubdepartment} from "redux/slices/PageMemory/StocksDepartmentPageSlice";
import { RootState } from "redux/store";
import { BulkEdit } from "../Popups/BulkEdit";
import { SelectSubDepartmentPopup } from "../Popups/SelectSubDepartmentPopup";
import { useStockFilter } from "hooks";

type DepartmentStocksProps = {
    departmentId: number;
}

export function DepartmentStocks(props: DepartmentStocksProps) {
    const dispatch = useAppDispatch();
    const getStockFilter = useStockFilter();
    const [bulkEditPopup, setBulkEditPopup] = useState(false);
    const stocks = useAppSelector((state: RootState) => state.stocks);
    const stockDepartmentPageSlice = useAppSelector((state: RootState) => state.stockDepartmentPageSlice);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const [showStockPopup, setShowStockPopup] = useState<boolean>(false);
    const [showSubDepartmentSelectorPopup, setShowSubDepartmentSelectorPopup] = useState<boolean>(false);

    const columnsb = [
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 100,
            Cell: (row: any) => user.permissions.managedStock.canUpdate ? <Link to={`/app/stock/${row.cell.row.original.id}`}>{row.cell.row.original.name}</Link> : <>{row.cell.row.original.name}</>,

        },
        {
            Header: "Sub Department",
            accessor: "departmentId",
            defaultCanSort: true,
            width: 800,
            Cell: (row: any) => {
                //@ts-ignore
                return (<>{stockDepartmentPageSlice.subDepartments.find(i => i.id === row.cell.row.original.subdepartmentId)?.name}</>);
            }
        },
    ];

   // useEffect(() => {
   //     if (subDepartments.loading && stockDepartmentPageSlice.subDepartments.length > 0) reloadDepartmentStock()
   // }, [subDepartments.loading]);

    useEffect(() => {
        columnCheckDeselectAll();
    }, [stockDepartmentPageSlice.pageSize]);

    function onSearchClick(keyword: string) {
        handleChange("stocksKeyword", keyword);
        handleChange("pageIndex", 0);
        columnCheckDeselectAll();
        reloadDepartmentStock(keyword);
    }

    function reloadDepartmentStock(keyword: string | undefined = undefined, subdepartments: number[] | undefined = undefined, offset: number | undefined = undefined, limit: number | undefined = undefined) {
        dispatch(getDepartmentStocks({
            keyword: keyword ?? stockDepartmentPageSlice.stocksKeyword,
            departmentIds: [props.departmentId],
            subdepartmentIds: subdepartments || stockDepartmentPageSlice.selectedSubDepartmentIds,
            offset: offset || (stockDepartmentPageSlice.pageIndex * stockDepartmentPageSlice.pageSize),
            limit: limit || stockDepartmentPageSlice.pageSize,
        }));
    }

    function handleChange(key: string, value: any) {
        dispatch(updateDepartmentField({ key: key, value: value }));
    }

    function updateTableRows(dataTableState: any) {
        handleChange("pageIndex", dataTableState.pageIndex);
        handleChange("pageSize", dataTableState.pageSize);

        reloadDepartmentStock(undefined, undefined, dataTableState.pageIndex * dataTableState.pageSize, dataTableState.pageSize);
    }

    function selectedRowsUpdate(rows: any, index: any) {
        dispatch(addSelectedRows({ rows: rows, index: index }));
    }

    function deselectedRowsUpdate(rows: any, index: any) {
        dispatch(addDeselectedRows({ rows: rows, index: index }));
    }

    function columnCheckDeselectAll() {
        handleChange("selectAllFilter", false);
        handleChange("deselectedStockRows", []);
        handleChange("selectedStockRows", []);
    }

    function columnCheckSelectAll() {
        handleChange("selectAllFilter", true);
        handleChange("deselectedStockRows", []);
    }

    function handleDeleteStocksInSubDepartment(deleteCallback: () => void) {
        dispatch(deleteStocksFromDepartment({
            filter: {
                ...(stockDepartmentPageSlice.stocksKeyword && { keyword: stockDepartmentPageSlice.stocksKeyword }),
                ids: (stockDepartmentPageSlice.selectAllFilter ? [] : getRowIds(stockDepartmentPageSlice.selectedStockRows)),
                excludedIds: (stockDepartmentPageSlice.selectAllFilter ? getRowIds(stockDepartmentPageSlice.deselectedStockRows) : []),
                departmentIds: [stockDepartmentPageSlice.id],
                subdepartmentIds: stockDepartmentPageSlice.selectedSubDepartmentIds
            },
            department: { isChanging: true, newValue: null, oldValue: stockDepartmentPageSlice.id },
            subDepartment: { isChanging: true, newValue: null, oldValue: null },
        })).then(() => {
            deleteCallback();
            columnCheckDeselectAll();
            reloadDepartmentStock();
        });
    }

    function handleCloseStockPopup() {
        setShowStockPopup(false);
        handleChange("selectedSubDepartment", 0);
        handleChange("selectedSubDepartmentIds", [...stockDepartmentPageSlice.selectedSubDepartmentIds]);
    }

    function handleSelectSubDeparmentContinue() {
        setShowSubDepartmentSelectorPopup(false);
        setShowStockPopup(true);
    }

    function managedStocksPopupSave() {
      
        let selectedStocks: any[] = [];
        let deselectedStocks: any[] = [];
        if (stocks.selectAllFilter) {
            deselectedStocks = getRowIds(stocks.deselectedRows);
        } else {
            selectedStocks = getRowIds(stocks.selectedRows);
        }
        dispatch(importStockToSubdepartment({
            filter: {
                ...getStockFilter(),
                ids: stocks.selectAllFilter == true? undefined: selectedStocks,
            },
            department: {
                isChanging: true,
                newValue: stockDepartmentPageSlice.id,
                oldValue: null,
            },
            subDepartment: {
                isChanging: true,
                newValue: stockDepartmentPageSlice.selectedSubDepartment,
                oldValue: null
            }
        })).then(() => {
            console.log(stockDepartmentPageSlice.subDepartments);           
            columnCheckDeselectAll();
            reloadDepartmentStock();
            setShowStockPopup(false);
        });
    }

    return (
        <>
            <h4 className="mt-2">Stocks</h4>
            <SelectSubDepartmentPopup subDepartmentId={"1"} show={showSubDepartmentSelectorPopup} onClose={()=>setShowSubDepartmentSelectorPopup(false)} onContinue={()=>handleSelectSubDeparmentContinue()} />
            <ManagedStocksPopup show={showStockPopup} onClose={()=>handleCloseStockPopup()} onSave={()=>managedStocksPopupSave()} />
            <BulkEdit show={bulkEditPopup} handleClose={() => setBulkEditPopup(false)} />
            <ProTable
                data={stockDepartmentPageSlice}
                pageSize={stockDepartmentPageSlice.pageSize}
                table={stockDepartmentPageSlice.stocksTable}
                isSortable={true}
                pagination={true}
                disableExport={true}
                columns={columnsb}
                loading={stockDepartmentPageSlice.loading}
                updateTableRows={updateTableRows}
                // Search Props
                isSearchable={true}
                searchPlaceHolder="by Name"
                onSearchClick={onSearchClick}
                // Select Props
                isSelectable={true}
                selectAllFilter={stockDepartmentPageSlice.selectAllFilter}
                selectedRows={stockDepartmentPageSlice.selectedStockRows}
                deselectedRows={stockDepartmentPageSlice.deselectedStockRows}
                selectedRowsUpdate={selectedRowsUpdate}
                deselectedRowsUpdate={deselectedRowsUpdate}
                columnCheckSelectAll={columnCheckSelectAll}
                columnCheckDeselectAll={columnCheckDeselectAll}
                // Toolbar Props
                handleSingleEdit={()=> setBulkEditPopup(true)}
                handleBulkEdit={()=> setBulkEditPopup(true) }
                addNewRow={()=>{setShowSubDepartmentSelectorPopup(true)}}
                removeRows={(deleteCallback) => handleDeleteStocksInSubDepartment(deleteCallback)}
                reloadTableRows={()=>reloadDepartmentStock()}
            />
        </>
    )
}